define
('pag_base',[
	'jquery'
	,
	'bootstrap-toolkit'
	,
	'GoogleAnalytics'
	,
	'jquery_dfp'
	,
	'lazysizes'
	,
	'ls_respimg'
	,
	'ls_bgset'
	,
	'ls_progressive'
	,
	'ls_fios'
	,
	'backbone'
	,
	'async'
	,
	'EventEmitter'
	,
	'd3_format'
	,
	'pace'
	,
	'busy'
	,
	'bootstrap_transition'
	,
	'bootstrap_modal'
	,
	'bootstrap_dropdown'
	// ,
	// 'bootstrap_alert'
	// ,
	// 'bootstrap_collapse'
	// ,
	// 'disqus'
	// ,
	// 'FileAPI'
	// ,
	// 'isotope'
	// ,
	// 'select2'
	// ,
	// 'bootstrap_datetimepicker'
	// ,
	// 'cookies'
	// ,
	// 'Waypoints'
	// ,
	// 'WaypointsSticky'
	// ,
	// 'bootbox'
	// ,
	// 'jquery_validate_es'
	// ,
	// 'fancybox'
	// ,
	// 'bootstrap_checkbox_x'
	// ,
	// 'inview'
	// ,
	// 'owlcarousel'
	// ,
	// 'bridget'
	// ,
	// 'Twitter'
	// ,
],
function
(
	jquery
	,
	bootstrapToolkit
	,
	GoogleAnalytics
	,
	jquery_dfp
	,
	lazySizes
	,
	respImg
	,
	bgSet
	,
	ls_progressive
	,
	ls_fios
	,
	Backbone
	,
	async
	,
	EventEmitter
	,
	d3_format
	,
	Pace
	,
	Busy
	// disqus,
	// FileAPI,
	// Isotope,
	// Select2,
	// bootstrap_datetimepicker,
	// Cookies,
	// Waypoints,
	// WaypointsSticky,
	// bootbox,
) {
	var youtube_obj;

	//--
	function mdlCleanUp(){
		//--
		var rows = document.querySelectorAll('.mdl-js-textfield');
		//--
		for (var i = 0, l = rows.length; i < l; i++) {
			if(typeof(rows[i].MaterialTextfield) === 'undefined'){
				// componentHandler.upgradeElement($(this)[0]);
				//--
				componentHandler.upgradeElement(rows[i]);
				//--
				setTimeout(function(){
					//--
					rows[i].MaterialTextfield.checkDirty();
				}, 500);
			}
			else{
				rows[i].MaterialTextfield.checkDirty();
			}
		}
	}

	window.date_info =
	{
		today: 			'Fecha de hoy',
		clear: 			'Limpiar selecciÃƒÂ³n',
		close: 			'Cerrar el selector',
		selectMonth: 	'Seleccionar mes',
		prevMonth: 		'Mes anterior',
		nextMonth: 		'Mes siguiente',
		selectYear: 	'AÃƒÂ±o siguiente',
		prevYear: 		'AÃƒÂ±o previo',
		nextYear: 		'AÃƒÂ±o siguiente',
		selectTime: 	'Seleccionar hora',
		selectDecade: 	'Seleccionar dÃƒÂ©cada',
		prevDecade: 	'DÃƒÂ©cada previa',
		nextDecade: 	'Siguiente dÃƒÂ©cada',
		prevCentury: 	'Centuria anterior',
		nextCentury: 	'Centuria siguiente'
	};
	window.date_icon =
	{
		time: 		'pict pict-timer',
		date: 		'pict pict-date_range',
		up: 		'pict pict-keyboard_arrow_up',
		down: 		'pict pict-keyboard_arrow_down',
		previous: 	'pict pict-keyboard_arrow_left',
		next: 		'pict pict-keyboard_arrow_right',
		today: 		'pict pict-today',
		clear: 		'pict pict-not_interested',
		close: 		'pict pict-close'
	};

	// console.log(ResponsiveBootstrapToolkit);

	//-- Wrap IIFE around your code
	(function($, document, window, viewport){
		window.obvp = viewport;

		// //--
		// var divs =
		// {
		// 	'ss': $('<div class="device-xxs visible-xxs visible-xxs-block"></div>'),
		// 	'xs': $('<div class="device-xs  visible-xs  visible-xs-block"></div>'),
		// 	'sm': $('<div class="device-sm  visible-sm  visible-sm-block"></div>'),
		// 	'md': $('<div class="device-md  visible-md  visible-md-block"></div>'),
		// 	'lg': $('<div class="device-lg  visible-lg  visible-lg-block"></div>')
		// };

		//--
		var spot_item 	= $('.note_spot_area .note_spot .spot_area');
		var file 		= 'part_spot';
		var info 		= null;
		var tryc 		= 2;

		//-- Confirm Mail
		var cm = function(){
			// //--
			// window.busy.Show();

			//--
			require(['busy', 'card', 'hbs!./../resources/views/hbs/hbs_part/_'+file], function ( Busy, Card, tmpl ) {

				//--
				if(typeof(window.busy) === 'undefined'){
					window.busy = Busy;
				}

				//--
				var data = {};
				data['_format'] = 'json';
				data['access_token'] = window.data.card;

				//--
				$.ajax({
					url: window.data.path.mail
					,
					method: 'POST'
					,
					dataType: "json"
					,
					data: data
					,
					complete:
					$.proxy(function(back, stat) {

						//--
						var spot = false;
						var stat = back.status ? back.status : stat;

						var file = '';
						var html = '';

						var time_hold = 250;

						//--
						// console.log('->'+stat);

						switch(stat)
						{
							//-- Success
							case 200:
								//--
								setTimeout(function(){
									//--
									info =  { "spot": [{"exit":true, "type":"done", "hide":true, "look":"edge--ss_t3x edge--ss_b3x", "name":""+window.data.user.name_first+", Ã‚Â¡tu cuenta ha sido activada!."}] };

									//--
									window.busy.Hide();
									//--
									html = tmpl(info);
									spot_item.html(html);
									//--
									setTimeout(function(){
										spot_item.find('.alert').addClass('in');
									}, 100);

								}, time_hold);
							break;
							//-- Prohibido
							case 403:
								//--
								setTimeout(function(){
									//--
									info =  { "spot": [{"exit":true, "type":"fail", "hide":true, "look":"edge--ss_t3x edge--ss_b3x", "name":"La acciÃƒÂ³n realizada no es permitida."}] };

									//--
									window.busy.Hide();
									//--
									html = tmpl(info);
									spot_item.html(html);
									//--
									setTimeout(function(){
										spot_item.find('.alert').addClass('in');
									}, 100);

								}, time_hold);
							break;
							//-- Datos invÃƒÂ¡lidos
							case 400:
								//--
								setTimeout(function(){
									//--
									info =  { "spot": [{"exit":true, "type":"fail", "hide":true, "look":"edge--ss_t3x edge--ss_b3x", "name":"Datos invÃƒÂ¡lidos."}] };

									//--
									window.busy.Hide();
									//--
									html = tmpl(info);
									spot_item.html(html);
									//--
									setTimeout(function(){
										spot_item.find('.alert').addClass('in');
									}, 100);

								}, time_hold);

							break;
							//-- No autorizado
							case 401:

								//--
								setTimeout(function(){
									//--
									info =  { "spot": [{"exit":false, "type":"hint", "hide":true, "look":"edge--ss_t3x edge--ss_b3x", "name":"Verificando datos. Por favor, espera..."}] };

									//--
									html = tmpl(info);
									spot_item.html(html);
									//--
									setTimeout(function(){
										spot_item.find('.alert').addClass('in');

										//--
										if (!--tryc)
										{


											//--
											setTimeout(function(){
												//--
												info =  { "spot": [{"exit":true, "type":"fail", "hide":true, "look":"edge--ss_t3x edge--ss_b3x", "name":"Tenemos un problema validando tu direcciÃƒÂ³n de correo."}] };

												//--
												window.busy.Hide();
												//--
												html = tmpl(info);
												spot_item.html(html);
												//--
												setTimeout(function(){
													spot_item.find('.alert').addClass('in');
												}, 100);

											}, time_hold);


										}
										else{
											//--
											window.busy.Show();

											//--
											setTimeout(function(){
												//-- But first, let me take a self... Just kidding, get the damm token pls
												Card.update(cm);
											}, 2000);
										}

									}, 100);

								}, time_hold);

							break;
							//-- No encontrado
							case 404:
								//--
								setTimeout(function(){
									//--
									info =  { "spot": [{"exit":true, "type":"fail", "hide":true, "look":"edge--ss_t3x edge--ss_b3x", "name":"No encontrado."}] };

									//--
									window.busy.Hide();
									//--
									html = tmpl(info);
									spot_item.html(html);
									//--
									setTimeout(function(){
										spot_item.find('.alert').addClass('in');
									}, 100);

								}, time_hold);
							break;
							//-- Conflictos
							case 409:
								//--
								setTimeout(function(){
									//--
									info =  { "spot": [{"exit":true, "type":"fail", "hide":true, "look":"edge--ss_t3x edge--ss_b3x", "name":"Hay un problema con la informaciÃƒÂ³n enviada."}] };

									//--
									window.busy.Hide();
									//--
									html = tmpl(info);
									spot_item.html(html);
									//--
									setTimeout(function(){
										spot_item.find('.alert').addClass('in');
									}, 100);

								}, time_hold);

							break;
							//-- Redirect
							case 301:
							break;
							//-- Error
							case 500:
								//--
								setTimeout(function(){
									//--
									info =  { "spot": [{"exit":true, "type":"fail", "hide":true, "look":"edge--ss_t3x edge--ss_b3x", "name":"Tenemos un problema validando tu direcciÃƒÂ³n de correo."}] };

									//--
									window.busy.Hide();
									//--
									html = tmpl(info);
									spot_item.html(html);
									//--
									setTimeout(function(){
										spot_item.find('.alert').addClass('in');
									}, 100);

								}, time_hold);

							break;
							//--
							default:
							break;
						}

					}, this)
				});

			});

		}

		//-- Check identity only if this user is registered and sign-in
		if(window.data.auth_sign == 1){

			if( !('undefined' === typeof(window.data.auth_card)) ){
				require(['busy', 'card', 'hbs!./../resources/views/hbs/hbs_part/_'+file], function ( Busy, Card, tmpl ) {

					//--
					if(typeof(window.busy) === 'undefined'){
						window.busy = Busy;
					}

					//-- Verified NOT.
					if(window.data.auth_card == -1){
						// console.log('Confirm: Revisa tu correo...');

						//--
						info =  { "spot": [{"exit":true, "type":"warn", "hide":true, "look":"edge--ss_t3x edge--ss_b3x", "name":"Estimado "+window.data.user.name_first+", hemos enviado un email a tu correo ("+window.data.user.mail+"), ve a tu bandeja y revisalo para activar tu cuenta de elfaro."}] };
						//--
						html = tmpl(info);
						spot_item.html(html);
						//--
						setTimeout(function(){
							spot_item.find('.alert').addClass('in');
						}, 100);

					}
					else{


						//-- Activate YEP. \-|-/
						if(window.data.auth_card == 0){
							// console.log('Confirm: Activando...');
							// //--
							// window.busy.Show();

							//--
							info =  { "spot": [{"exit":false, "type":"hint", "hide":true, "look":"edge--ss_t3x edge--ss_b3x", "name":"Verificando datos. Por favor, espera..."}] };

							//--
							html = tmpl(info);
							spot_item.html(html);
							//--
							setTimeout(function(){
								spot_item.find('.alert').addClass('in');

								//--
								setTimeout(function(){

									// window.data.card = 'este_es_un_key_invÃƒÂ¡lido_de_prueba';

									//--
									if( 'undefined' === typeof(window.data.card) || window.data.card=='' || !window.data.card ){
										//-- But first, let me take a self... Just kidding, get the damm token
										Card.update(cm);
									}
									else{
										//--
										cm();
									}

								}, 1000);


							}, 100);
						}
						else{
							//-- Only if we need
							// if(window.data.auth_card == 1){

							// 	//--
							// 	if( 'undefined' === typeof(window.data.card) || window.data.card=='' || !window.data.card ){
							// 		//-- But first, let me take a self... Just kidding, get the damm token
							// 		Card.update();
							// 	}

							// }
						}


					}

				});
			}
		}

		//--
		window.resp = function(view){

			//--
			if(view) {
				// console.log('viewport_current: '+view.current());

				//--
				// console.info('view: ', view);
			}


			//-- Tick
			if(view && view.is('>xs')) {
				//--
				// console.info('view > xs');


				//--
				// console.info('Activate: Tick');
				//--
				if( 0 < $('#tick_area').length )
				{


					//--
					require(['jquery-mousewheel', 'malihu_custom_scrollbar_plugin'], function (jquery_mousewheel, malihu_custom_scrollbar_plugin){


						//--
						var atom_tall 		= 5;

						//--
						var list_jobj 		= $('#home_list');
						var talk_jobj 		= $('#home_talk');
						var blog_jobj 		= $('#home_blog');
						var tick_jobj 		= $('#home_tick');
						var gutt_jobj 		= $('.gutt_line');
						var head_name_jobj 	= $('.head_name');
						var list_line_jobj 	= $('.list_line');

						//--
						list_dath 			= list_jobj.height();
						talk_dath 			= talk_jobj.height();
						talk_dath 			= 0;
						blog_dath 			= blog_jobj.height();
						tick_dath 			= tick_jobj.height();
						gutt_dath 			= gutt_jobj.height();
						head_name_dath 		= head_name_jobj.height();
						list_line_dath 		= list_line_jobj.height();

						// //--
						// console.log('list_dath: '+list_dath);
						// console.log('talk_dath: '+talk_dath);
						// console.log('blog_dath: '+blog_dath);
						// console.log('tick_dath: '+tick_dath);
						// console.log('gutt_dath: '+gutt_dath);
						// console.log('head_name_dath: '+head_name_dath);
						// console.log('list_line_dath: '+list_line_dath);

						//--
						tick_dath = list_dath - ( talk_dath + blog_dath + head_name_dath + (list_line_dath * 1) + (gutt_dath * 1) );
						tick_jobj.find('#tick_area').css({ 'height': tick_dath+'px' });
						tick_jobj.find('#tick').css({ 'height': tick_dath+'px' });

						//--
						var atom_tall = 5;

						// console.log('>xs');

						//--
						// $("#tick_area").mCustomScrollbar("destroy");
						if( $("#tick_area").data("mCS") ){
							//--
							$("#tick_area").mCustomScrollbar("update");
						}
						else
						{
							// --
							$("#tick_area #tick").css({'width': 'auto' });

							//--
							$("#tick_area").mCustomScrollbar("destroy");
							$("#tick_area").mCustomScrollbar({
								// ,
								'theme': 'minimal-dark'
								// 'theme':"dark-thick"
								,
								'scrollInertia': 0
								,
								'alwaysShowScrollbar': 1
								,
								'scrollButtons': { 'enable': false }
								,
								'autoHideScrollbar': false
								,
								'axis': "y"
								,
								'mouseWheel': true
								,
								'scrollbarPosition': "inside"
								,
								'callbacks':{
									onInit:function(){
										// console.log("Scrollbars initialized");
										// lazySizes.loader.checkElems();
									}
								}
							});
						}
					});


				}
			}


			//-- Tick
			// if(view && view.is('>sm')) {
			if(view && view.is('>=xs')) {
				// //--
				// console.info('view >= xs');


				//--
				// console.info('Activate: Meny Side Stuk');
				//--
				posa 			= document.getElementById('pos_a');
				area_posa 		= document.getElementById('pos_a_area');
				area_posb 		= document.getElementById('pos_b_area');
				var hand_init;
				var init_make;

				if(area_posa && area_posb){
					//--
					if(posa.offsetHeight > area_posb.offsetHeight){
						area_posa.style.height = posa.offsetHeight+'px';
					}
					else{
						area_posa.style.height = area_posb.offsetHeight+'px';
					}
				}
				// console.log('posa.offsetHeight: ', posa.offsetHeight);
				// console.log('area_posb: ', area_posb.offsetHeight);

				//-- Create waypoints
				require(['Waypoints', 'WaypointsSticky'], function (Waypoints, WaypointsSticky){

					if(window.tick_side_head != null && window.tick_side_foot != false ){
						//--
						Waypoint.refreshAll();
					}
					else{

						//--
						//-- Side
						//--
						if( 0 < $('.sidebar').length )
						{
							if(
								window.data.tmpl_slug=="home" ||
								window.data.tmpl_slug=="single" ||
								window.data.tmpl_slug=="section" /*||
								window.data.tmpl_slug=="case"*/
								// window.data.tmpl_slug!="post_pict_only"
								// &&
								// window.data.tmpl_slug!="post_pict_many"
								// &&
								// window.data.tmpl_slug!="post_view_full"
							)
							{
								//--
								make_init = ($('.sidebar').offset()).top;
								init_make = 60;

								//--
								window.tick_side_head =
								new Waypoint.Sticky({
									element : $('.sidebar')[0]
									,
									offset: init_make
									,
									handler:
									function(direction) {
										// console.log('Controles Top '+$('.seccion_registro').outerHeight(true));
										//--
										// $('.sidebar_area').css({'height': $('.article_area').outerHeight(true)+'px'});
										//--
										if($('.sidebar').hasClass('stuck-top')){
											$('.sidebar').removeClass('stuck-top');
											$('.sidebar').addClass('static');
										}
										else
										{
											$('.sidebar').removeClass('static');
											$('.sidebar').addClass('stuck-top');
										}
										// $('.sidebar').css({'width': $('.sidebar_area').outerWidth(true)+'px'});
										// $('.sidebar').toggleClass('stuck-bottom');
									}
								});

								//--
								window.tick_side_foot = new Waypoint.Sticky({
									  element : $('.main_foot')[0]
									, handler: function(direction) {
										// console.log('Controles Bottom');
										//--
										$('.sidebar').toggleClass('stuck-bottom');
									}
									,
									offset: /*make_init + */ $('.sidebar').outerHeight(true) + 60/*-$('.main_menu_b').outerHeight(true)+10+0*/
								});

								//--
								// Responsejs

								// if(window.tick_side == 220){
								// 	window.tick_side.destroy()
								// }
							}
						}

						//--
						//-- Head
						//--
						if(0 < $('.main_head').length )
						{

							if(
								window.data.tmpl_slug=="home" ||
								window.data.tmpl_slug=="single" ||
								window.data.tmpl_slug=="section" /*||
								window.data.tmpl_slug=="case"*/
							)
							{

								//--
								if(window.tick_ctrl_head != null && window.tick_ctrl_foot != false ){
									//--
									Waypoint.refreshAll();
								}
								else{
									hand_init = 45;
									make_init = ($('.main_head').offset()).top;
									init_make = (-hand_init);
									// console.log('hand_init: '+hand_init);
									//--
									window.tick_ctrl_head =
									new Waypoint.Sticky({
										element : $('.main_head')[0]
										,
										offset: init_make
										,
										handler:
										function(direction) {
											// console.log('Controles Top '+$('.seccion_registro').outerHeight(true));
											//--
											// $('.main_head_area').css({'height': $('.article_area').outerHeight(true)+'px'});
											//--
											if($('.main_head').hasClass('stuck-top')){
												$('.main_head').removeClass('stuck-top');
												$('.main_head').addClass('static');
											}
											else
											{
												$('.main_head').removeClass('static');
												$('.main_head').addClass('stuck-top');
											}
											// $('.main_head').css({'width': $('.main_head_area').outerWidth(true)+'px'});
											// $('.main_head').toggleClass('stuck-bottom');
										}
									});
									//--
									window.tick_ctrl_foot = new Waypoint.Sticky({
										  element : $('.main_foot')[0]
										, handler: function(direction) {
											// console.log('Controles Bottom');
											//--
											$('.main_head').toggleClass('stuck-bottom');
										}
										,
										offset: make_init+$('.main_head').outerHeight(true)-hand_init
									});
								}
							}


							if(window.data.link=="forocap.elfaro.dev")
							{


								if(window.tick_ctrl_pict_head != null && window.tick_ctrl_pict_foot != false ){
									//--
									Waypoint.refreshAll();
								}
								else{
									hand_pict = 0;
									save_pict = ($('.main_head').offset()).top;
									init_pict = (-hand_pict);
									// console.log('hand_pict: '+hand_pict);
									//--
									window.tick_ctrl_pict_head =
									new Waypoint.Sticky({
										element : $('.main_head')[0]
										,
										stuckClass : 'fixd_pict'
										,
										offset: init_pict
										,
										handler:
										function(direction) {
											// console.log('Hand Navi '+'Triggered');
											//--
											if($('.main_head').hasClass('stuk_pict')){
												$('.main_head').removeClass('stuk_pict');
												$('.main_head').addClass('fixd_stat');
											}
											else
											{
												$('.main_head').removeClass('fixd_stat');
												$('.main_head').addClass('stuk_pict');
											}
										}
									});

									window.tick_ctrl_pict_foot = new Waypoint.Sticky({
										  element : $('.main_foot')[0]
										, handler: function(direction) {
											// console.log('Controles Bottom');
											//--
											$('.main_head').toggleClass('stuk_pict');
										}
										,
										offset: save_pict+$('.main_head').outerHeight(true)-hand_pict
									});
								}

								//--




								if(window.tick_ctrl_deep_head != null && window.tick_ctrl_deep_foot != false ){
									//--
									Waypoint.refreshAll();
								}
								else{
									hand_navi = 50;
									save_navi = ($('.main_head').offset()).top;
									init_navi = (-hand_navi);
									// console.log('hand_navi: '+hand_navi);
									//--
									window.tick_ctrl_deep_head =
									new Waypoint.Sticky({
										element : $('.main_head')[0]
										,
										stuckClass : 'fixd_stuk'
										,
										offset: init_navi
										,
										handler:
										function(direction) {
											// console.log('Hand Navi '+'Triggered');
											//--
											if($('.main_head').hasClass('stuk_navi')){
												$('.main_head').removeClass('stuk_navi');
												$('.main_head').addClass('fixd_stat');
											}
											else
											{
												$('.main_head').removeClass('fixd_stat');
												$('.main_head').addClass('stuk_navi');
											}
										}
									});

									window.tick_ctrl_deep_foot = new Waypoint.Sticky({
										  element : $('.main_foot')[0]
										, handler: function(direction) {
											// console.log('Controles Bottom');
											//--
											$('.main_head').toggleClass('stuk_navi');
										}
										,
										offset: save_navi+$('.main_head').outerHeight(true)-hand_navi
									});
								}
							}


							if(
								window.data.tmpl_slug=="main_only" ||
								window.data.tmpl_slug=="main_page_only" ||
								window.data.tmpl_slug=="main_anim_only" ||
								window.data.tmpl_slug=="main_graf_only" ||
								window.data.tmpl_slug=="main_dany_only" ||
								window.data.tmpl_slug=="case"
								)
							{
								//--
								if(window.tick_ctrl_pict_head != null && window.tick_ctrl_pict_foot != false ){
									//--
									Waypoint.refreshAll();
								}
								else{
									hand_pict = 0;
									save_pict = ($('.main_head').offset()).top;
									init_pict = (-hand_pict);
									// console.log('hand_pict: '+hand_pict);
									//--
									window.tick_ctrl_pict_head =
									new Waypoint.Sticky({
										element : $('.main_head')[0]
										,
										stuckClass : 'fixd_pict'
										,
										offset: init_pict
										,
										handler:
										function(direction) {
											// console.log('Hand Navi '+'Triggered');
											//--
											if($('.main_head').hasClass('stuk_pict')){
												$('.main_head').removeClass('stuk_pict');
												$('.main_head').addClass('fixd_stat');
											}
											else
											{
												$('.main_head').removeClass('fixd_stat');
												$('.main_head').addClass('stuk_pict');
											}
										}
									});

									window.tick_ctrl_pict_foot = new Waypoint.Sticky({
										element : $('.main_foot')[0]
										,
										handler: function(direction) {
											// console.log('Controles Bottom');
											//--
											$('.main_head').toggleClass('stuk_pict');
										}
										,
										offset: save_pict+$('.main_head').outerHeight(true)-hand_pict
									});
								}


								//--
								if(window.tick_ctrl_deep_head != null && window.tick_ctrl_deep_foot != false ){
									//--
									Waypoint.refreshAll();
								}
								else
								{
									// hand_navi = 50;
									hand_navi = 0;
									save_navi = ($('.main_head').offset()).top;
									init_navi = (-hand_navi);
									// console.log('hand_navi: '+hand_navi);

									//--
									window.tick_ctrl_deep_head =
									new Waypoint.Sticky({
										element : $('.main_head')[0]
										,
										stuckClass : 'fixd_stuk'
										,
										offset: init_navi
										,
										handler:
										function(direction) {
											// console.log('Hand Navi '+'Triggered');
											//--
											if($('.main_head').hasClass('stuk_navi')){
												$('.main_head').removeClass('stuk_navi');
												$('.main_head').addClass('fixd_stat');
											}
											else
											{
												$('.main_head').removeClass('fixd_stat');
												$('.main_head').addClass('stuk_navi');
											}
										}
									});

									window.tick_ctrl_deep_foot = new Waypoint.Sticky({
										element : $('.main_foot')[0]
										,
										handler: function(direction) {
											// console.log('Controles Bottom');
											//--
											$('.main_head').toggleClass('stuk_navi');
										}
										,
										offset: save_navi+$('.main_head').outerHeight(true)-hand_navi
									});
								}
							}


							if(
								// window.data.tmpl_slug=="main_only" ||
								window.data.tmpl_slug=="single"
							)
							{
								//--
								if(window.tick_ctrl_pict_head != null && window.tick_ctrl_pict_foot != false ){
									//--
									Waypoint.refreshAll();
								}
								else{
									// hand_pict = 0;
									hand_pict = 0;
									save_pict = ($('.main_head').offset()).top;
									init_pict = (-hand_pict);
									// console.log('hand_pict: '+hand_pict);
									//--
									window.tick_ctrl_pict_head =
									new Waypoint.Sticky({
										element : $('.main_head')[0]
										,
										stuckClass : 'fixd_pict'
										,
										offset: init_pict
										,
										handler:
										function(direction) {
											// console.log('Hand Navi '+'Triggered');
											//--
											if($('.main_head').hasClass('stuk_pict')){
												$('.main_head').removeClass('stuk_pict');
												$('.main_head').addClass('fixd_stat');
											}
											else
											{
												$('.main_head').removeClass('fixd_stat');
												$('.main_head').addClass('stuk_pict');
											}
										}
									});

									window.tick_ctrl_pict_foot = new Waypoint.Sticky({
										element : $('.main_foot')[0]
										,
										handler: function(direction) {
											// console.log('Controles Bottom');
											//--
											$('.main_head').toggleClass('stuk_pict');
										}
										,
										offset: save_pict+$('.main_head').outerHeight(true)-hand_pict
									});
								}


								//--
								if(window.tick_ctrl_deep_head != null && window.tick_ctrl_deep_foot != false ){
									//--
									Waypoint.refreshAll();
								}
								else
								{
									hand_navi = 50;
									save_navi = ($('.main_head').offset()).top;
									init_navi = (-hand_navi);
									// console.log('hand_navi: '+hand_navi);

									//--
									window.tick_ctrl_deep_head =
									new Waypoint.Sticky({
										element : $('.main_head')[0]
										,
										stuckClass : 'fixd_stuk'
										,
										offset: init_navi
										,
										handler:
										function(direction) {
											// console.log('Hand Navi '+'Triggered');
											//--
											if($('.main_head').hasClass('stuk_navi')){
												$('.main_head').removeClass('stuk_navi');
												$('.main_head').addClass('fixd_stat');
											}
											else
											{
												$('.main_head').removeClass('fixd_stat');
												$('.main_head').addClass('stuk_navi');
											}
										}
									});

									window.tick_ctrl_deep_foot = new Waypoint.Sticky({
										element : $('.main_foot')[0]
										,
										handler: function(direction) {
											// console.log('Controles Bottom');
											//--
											$('.main_head').toggleClass('stuk_navi');
										}
										,
										offset: save_navi+$('.main_head').outerHeight(true)-hand_navi
									});
								}
							}


						}
					}

				});
			}


			//-- Menu Mini
			if( (view && view.is('<md')) || window.data.full=="0" || window.data.full=="1" || window.data.full=="2") {
				//--
				// console.info('view < md');
				//--
				// console.info('Activate: Menu Mini');

				var API = false;

				//--
				if($("#menu_ring").length > 0 ){
					API = $("#menu_ring").data( "mmenu" );
				}

				// console.log('API:' + 'MENU RING');

				//--
				if(!API){
					// console.log('!API' + '');
					//-- Create menu
					require(['jquery_mmenu_all_min_js'], function (jquery_mmenu_all_min_js){
						// console.log('Require:' + 'jquery_mmenu_all_min_js');

						//--
						$("#menu_ring")
						.mmenu
						(
							{
								"iconPanels":
								{
									"add": true
									// ,
									// "hideNavbars": true
								}
								,
								"offCanvas":
								{
									"position": "left"
									,
									'pageSelector': "#site"
									// ,
									// "pageNodetype": "section"
								}
								,
								"extensions":
								[
									// "effect-menu-slide"
									// ,
									"effect-panels-slide-100"
									,
									// "effect-listitems-drop"
									// ,
									// "effect-listitems-slide"
									// ,
									"theme-white"
									,
									"pagedim-black"
									,
									"pageshadow"
									,
									"border-full"
									// ,
									// "justified-listview"
								]

							}
							,
							{
								offCanvas:
								{
									// position: "right"
									// ,
									pageSelector: "#site"
								}
							}
						);

						//--
						var API = $("#menu_ring").data( "mmenu" );

						if(API){
							//--
							API.bind( "openPanel", function( $panel ) {
								// console.log( "This panel is now opened:" + $panel.attr( "id" ) );
							});
							//--
							API.bind( "closePanel", function( $panel ) {
								// console.log( "This panel is now closed:" + $panel.attr( "id" ) );
							});
							//--
							API.bind( "update", function( $panel ) {
								// console.log( "This panel is now update:" + $panel.attr( "id" ) );
							});
							//--
							API.bind( "init", function( $panel ) {
								// console.log( "init:");
							});

							//--
							$("#hamburger").on('click', function() {
								console.log('$("#hamburger")');
								//--
								var item = $(this);
								// console.log('menu_ring click');
								//--
								// if(item.hasClass('is-active')){
								// 	item.remove('is-active');
								// 	API.close();
								// }
								// else{
								// 	item.addClass('is-active');
								// 	API.open();
								// }
								//--
								API.open();
								//--
								// item.toggleClass('is-active');
							});
						}

					});
				}

				// //--
				// if(window.tick_side != null && window.tick_side != false ){
				// 	//--
				// 	window.tick_side.destroy();
				// }
			}


			//-- Menu Side
			if(view && view.is('>md')) {
				// console.info('view > md');
			}


			var posa			= null;
			var area_posa		= null;
			var area_posa		= null;
			var area_tall		= null;

			posa 			= document.getElementById('pos_a');
			area_posa 		= document.getElementById('pos_a_area');
			area_posb 		= document.getElementById('pos_b_area');
			if(area_posa && area_posb){
				if( (posa.offsetHeight > area_posb.offsetHeight)){
					// area_posa.style.height = posa.offsetHeight+'px';
					area_tall = posa.offsetHeight;
				}
				else{
					area_tall = area_posb.offsetHeight;
					// area_posa.style.height = area_posb.offsetHeight+'px';
				}
				area_posa.style.height = area_tall+'px';
			}

		}

		// //--
		// view.use('Custom', divs);

		//--
		$(document).ready(function() {
			//--
			// console.log('Current breakpoint (ready):', viewport.current());

			if(0 == $('html.html_nake').length){
				//--
				window.resp(viewport);

				//-- Execute, each time window size changes
				$(window).resize(
					viewport.changed(function() {
						//--
						// console.log('Current breakpoint (change):', viewport.current());

						//-- Stuck
						window.resp(viewport);

					})
				);


				//--
				if(
					window.data.tmpl_slug=="single" ||
					window.data.tmpl_slug=="main_only" ||
					window.data.tmpl_slug=="main_graf_only" ||
					window.data.tmpl_slug=="main_anim_only" ||
					window.data.tmpl_slug=="main_dany_only"
				)
				{

					//--
					if(window.data.coin_sure == '1'){

						//--
						window.busy.Show();

						//--
						require(['jquery_validate_am', 'bootstrap_datetimepicker', 'mdl_tabs', 'mdl_button', 'mdl_textfield', 'mdl_ripple', 'moment', 'moment/locale/es', 'stripe_checkout', 'jquery-scrollto'],
							function(jquery_validate_am, bootstrap_datetimepicker, mdl_tabs, mdl_button, mdl_textfield, mdl_ripple, moment ) {

								// console.log();

								//-- Handler
								var hand = StripeCheckout.configure({
									key: window.data.coin_data,
									// image: window.schm +window.conf_pict_logo,
									image: window.conf_pict_logo,
									locale: 'auto',
									token: function(token) {
										// You can access the token ID with `token.id`.
										// Get the token ID to your server-side code for use.
									}
								});

								//--
								window.busy.Hide();

								//-- custom validator for money fields
								jQuery.validator.addMethod("money", function(value, element) {
									return this.optional(element) || /^\$?[0-9][0-9\,]*(\.\d{1,2})?$|^\$?[\.]([\d][\d]?)$/.test(value);
								}, "Escribe una cantidad en dólares");

								//--
								var form_type      = 'send';
								var form_send_rulz = {
									card_name:
									{
										required: true
										,
										minlength: 1
										,
										maxlength: 120
									}
									,
									card_mail:
									{
										required: true
										,
										email: true
										// ,
										// minlength: 4
										,
										maxlength: 120
									}
									,
									card_coin:
									{
										required: true
										,
										money: true
									}
									// ,
									// card_cvc:
									// {
									// 	required: true
									// 	,
									// 	minlength: 6
									// 	,
									// 	maxlength: 6
									// }
									// ,
									// card_mail:
									// {
									// 	required: true
									// 	,
									// 	email: true
									// 	,
									// 	minlength: 4
									// 	,
									// 	maxlength: 120
									// }
									// , phone:
									// {
									// 	required: true
									// 	, minlength: 8
									// 	, maxlength: 8
									// }
								};
								form_send = $('.form_'+form_type+'_area form');

								// console.log('Init Form_send_Look');
								window.form_send_look = form_send.validate({
									ignore: ""
									// ignore: ':hidden:not("#off_val, #trip_ty")',
									, rules: form_send_rulz
									,
									messages:
									{
										card_name:
										{
											required: "Escribe tu nombre"
										}
										,
										card_mail:
										{
											required: "Escribe tu email",
											email: "Escribe un email válido"
										}
										,
										card_coin:
										{
											required: "Requerido",
											money: "Monto en dólares"
											// minlength: jQuery.format("Enter at least {0} characters"),
											// remote: jQuery.format("{0} is already in use")
										}
									}
									, invalidHandler: function(event, validator) {

									}
									, showErrors: function (bugsMap, bugsList) {
										// $("#summary").html("Your form contains " + this.numberOfInvalids() + " bugs:");
										this.defaultShowErrors();
										// console.log(bugsList);
										//-- 'this' refers to the form
										var bugs = form_send_look.numberOfInvalids();
										// console.log('invalidHandler: '+bugs);
										if (bugs) {
											// console.log('Formulario SI tiene bugses');
											// var message = bugs == 1
											// ? 'You missed 1 field. It has been highlighted'
											// : 'You missed ' + bugs + ' fields. They have been highlighted';
											// $("div.bugs span").html(message);
											// $("div.bugs").show();
										}
										else
										{
											// console.log('Formulario NO tiene bugses');
											// $("div.bugs").hide();
										}
									}
									, errorElement: 'em'
									, errorClass: 'mdl-textfield__error'
									, errorPlacement: function(bugs, item) {
										// console.log(item.parent().find('.mdl-textfield__error_first').length);
										// console.log(item.parent().find('.mdl-textfield__error_first').length > 0);

										//--
										// if(item.parent().find('.mdl-textfield__error_first').length > 0){
										// 	item.parent().find('.mdl-textfield__error_first').remove();
										// }
										if(item.parent().find('.mdl-textfield__error').length > 0){
											item.parent().find('.mdl-textfield__error').remove();
										}
										//-- danger
										//-- text
										//--
										bugs.addClass('tint-text--fail text_normal block full-width mdl-textfield__error');
										//--
										if(item.parent('.input-group').length) {
											bugs.insertAfter(item.parent());
										}
										else
										{
											// bugs.insertAfter(item);
											item.parent().append(bugs);
										}
									}
									, highlight: function (item, bugsClass, validClass) {
										//-- 'this' refers to the form
										var bugs = form_send_look.numberOfInvalids();
										// console.log('invalidHandler: '+bugs);
										// console.log('Formulario SI tiene bugses');

										$(item).closest('.mdl-textfield').removeClass('is-invalid has-feedback').addClass('is-invalid has-feedback');
										// $(item).closest('.form-group').find('.fa').remove();
										// $(item).closest('.form-group').append('<i class="fa fa-times fa-lg form-control-feedback"></i>');
									}
									, unhighlight: function (item, bugsClass, validClass) {
										// console.log('Formulario NO tiene bugses');
										$(item).closest('.mdl-textfield').removeClass('is-invalid has-feedback').addClass('is-valid has-feedback');
										// $(item).closest('.form-group').find('.fa').remove();
										// $(item).closest('.form-group').append('<i class="fa fa-check fa-lg form-control-feedback"></i>');
									}
									, submitHandler: function(form) {
										//--
										window.busy.Show();

										//-- Path
										// var path 			= '/api/users/money.json';
										var path 			= window.data.post.link;
										var path_user 		= '/dashboard';
										//--
										var send 			= form_send.find('button.send');
										// var socl 			= form_send_socl.find('button.socl');
										//--
										var send_text_init 	= send.attr('data-text-init');
										var send_text_wait 	= send.attr('data-text-wait');
										var send_text_done 	= send.attr('data-text-done');
										//--
										var send_pict_init 	= send.attr('data-pict-init');
										var send_pict_wait 	= send.attr('data-pict-wait');
										var send_pict_done 	= send.attr('data-pict-done');
										//--
										// var spot_item 	= form_send.find('.step_spot_area .step_spot .spot_area');


										//--
										// console.log('send_text_init->'+' '+send_text_init);
										// console.log('send_text_wait->'+' '+send_text_wait);
										// console.log('send_text_done->'+' '+send_text_done);
										// //--
										// console.log('send_pict_init->'+' '+send_pict_init);
										// console.log('send_pict_wait->'+' '+send_pict_wait);
										// console.log('send_pict_done->'+' '+send_pict_done);


										var data = {};
										var info = {};
										var time_hold = 250;
										var card_coin_view = $('input[name="card_coin"]').val();
										var card_coin_real = card_coin_view;
										var card_mail = $('input[name="card_mail"]').val();
										//--
										card_coin_view = card_coin_view.replace("$", "");;
										card_coin_real = card_coin_real.replace("$", "");;
										if($.isNumeric(card_coin_real)){
											card_coin_real = (parseFloat(card_coin_real));
										}
										else{
											card_coin_real = 5;
										}
										//--
										card_coin_real = (card_coin_real)*100;

										var token_hook = false;
										// data = form_send.serialize();


										// data.push({name: "line", value: 'Stripe'});
										// data.push({name: "echo", value: '----'});
										data["type"]= '';
										data["name"]= form_send.find('input[name="card_name"]').val();
										data["line"]= 'Stripe';
										data["mail"]= form_send.find('input[name="card_mail"]').val();
										data["coin_real"]= card_coin_real;
										data["coin_view"]= card_coin_view;
										data["sign"]= 'Excavación Ciudadana - '+'Apoyo voluntario por $'+card_coin_view;
										// data["text"]= form_send.find('.data_head').attr('data-rand');
										// data["text"]= form_send.find('.data_head').text();
										data["text"]= ($('.data_head').text()).trim();
										data["echo"]= '----';
										data["ug"]= 1;
										data["send_coin"]= 1;

										//--
										send.addClass('mdl-button--disabled');
										// socl.addClass('mdl-button--disabled');

										var send_mail = function(){
											//--
											window.busy.Show();

											//--
											$.ajax({
												// url: window.BB.routes.entrar,
												url: path
												,
												method: 'POST'
												,
												dataType: "json"
												,
												data: data
												,
												complete:
												$.proxy(function(back, stat) {

													//--
													window.busy.Hide();

													//--
													var spot = false;
													var stat = back.status ? back.status : stat;

													var file = '';
													var html =  '';
													var data =  {};

													//--
													// console.log('->'+stat);

													switch(stat)
													{
														//-- Success
														case 200:
															//--
														break;
														//-- Invalid password
														case 403:
															//--
														break;
														//-- Datos inválidos
														case 400:
															//--
														break;
														//-- No autorizado
														case 401:
														break;
														//--
														case 404:
															//--
														break;
														//--
														case 409:
															//--
														break;
														//-- Redirect
														case 301:
															//--
														break;
														//-- Error
														case 500:
															//--
														break;
														//--
														default:
															//--
														break;
													}

												}, this)
											});
										}


										//-- Open Checkout with further options:
										hand.open({
											name: 'Excavación Ciudadana',
											// panelLabel: 'Dar apoyo $',
											email: card_mail,
											allowRememberMe: true,
											description: 'Apoyo voluntario por $'+card_coin_view,
											amount: card_coin_real,
											locale: 'auto',
											zipCode: false,
											closed:
											function(){
												// console.log('Ventana cerrada');
												// window.busy.Hide();
												send.removeClass('mdl-button--disabled');

												if (!token_hook) {
													//-- Close button click behavior goes here
													// console.log('Pago NO completado');
													//--
													data["type"] = 'Skip';

												}
												else
												{
													//--
													data["type"] = 'Shot';
													//--
													$('.line_head .data_head .__content').text('¡Gracias por tu aporte!');
													$('.line_text .data_text .__content').text('Con tu ayuda podremos continuar haciendo periodismo de investigación');
													// $('.line_text').addClass('fade in');
													$('.line_text').removeClass('hide');
													$('.line_text').addClass('fade in');
													$('.line_form').addClass('fade hide');
													//-- Payment completion behavior goes here
													// console.log('Pago SÍ completado');
												}
												//--
												send_mail();

											},
											token: function(tokn) {
												// console.log('tokn:', tokn);

												//--
												data["tokn"] = tokn.id;
												data["root"] = tokn.client_ip;
												data["kind"] = tokn.type;
												token_hook = true;
											}
										});
										// e.preventDefault();


										//-- Close Checkout on page navigation:
										window.addEventListener('popstate', function() {
											hand.close();
											// window.busy.Hide();
											send.removeClass('mdl-button--disabled');
											// console.log('Pago cancelado');
										});


										//--
										return false;
									}
								});


								//--
								form_send.on( 'click', 'button.send', function(hook) {
									//--
									// window.busy.Show();
									//--
									hook.preventDefault();
									form_send.submit();
								});


								//--
								if(window.data.coin_sure == '1'){
									var text_data = $('.data_coin .mdl-textfield__input');
									var text_full = $('.mdl-textfield__input');

									//--
									text_full.each(function(){
										//--
										componentHandler.upgradeElement( $(this).parent()[0] );
										$(this).parent().get(0).MaterialTextfield.checkDirty();
									});

									//--
									text_data.each(function(){
										text_data.val('$5.00');
										//--
										componentHandler.upgradeElement( $(this).parent()[0] );
										$(this).parent().get(0).MaterialTextfield.checkDirty();
									});


									//--
									setTimeout(function(){
										$('.give_coin .data_nook')
										.animate
										(
											{'opacity': 1}
											,
											{
												duration: 800,
												queue: false,
												complete:
												function()
												{
												}
											}
										);
										$('.give_coin .data_nook')
										.animate
										(
											{'left': '0px'}
											,
											{
												duration: 800,
												queue: false,
												complete:
												function()
												{
												}
											}
										);
									}, 0);


									//--
									$('.give_coin .data_head')
									.animate
									(
										{'opacity': 1}
										,
										{
											duration: 800,
											queue: false,
											complete:
											function()
											{
											}
										}
									);
									//--
									$('.give_coin .data_head')
									.animate
									(
										{'left': '0px'}
										,
										{
											duration: 800,
											queue: false,
											complete:
											function()
											{
											}
										}
									);


									//--
									$('.give_coin .data_name')
									.animate
									(
										{'opacity': 1}
										,
										{
											duration: 800,
											queue: false,
											complete:
											function()
											{
											}
										}
									);
									$('.give_coin .data_name')
									.animate
									(
										{'top': '0px'}
										,
										{
											duration: 800,
											queue: false,
											complete:
											function()
											{
											}
										}
									);


									//--
									$('.give_coin .data_mail')
									.animate
									(
										{'opacity': 1}
										,
										{
											duration: 800,
											queue: false,
											complete:
											function()
											{
											}
										}
									);
									$('.give_coin .data_mail')
									.animate
									(
										{'top': '0px'}
										,
										{
											duration: 800,
											queue: false,
											complete:
											function()
											{
											}
										}
									);


									//--
									$('.give_coin .data_coin')
									.animate
									(
										{'opacity': 1}
										,
										{
											duration: 800,
											queue: false,
											complete:
											function()
											{
											}
										}
									);
									$('.give_coin .data_coin')
									.animate
									(
										{'top': '0px'}
										,
										{
											duration: 800,
											queue: false,
											complete:
											function()
											{
											}
										}
									);


									//--
									$('.give_coin .data_hook')
									.animate
									(
										{'opacity': 1}
										,
										{
											duration: 800,
											queue: false,
											complete:
											function()
											{
											}
										}
									);
									$('.give_coin .data_hook')
									.animate
									(
										{'top': '0px'}
										,
										{
											duration: 800,
											queue: false,
											complete:
											function()
											{
											}
										}
									);

								}


							}
						);
					}

				}
			}


		});
	})(jQuery, document, window, ResponsiveBootstrapToolkit);




	// console.log('d3');
	// console.log(d3)
	//-- s
	Pace.start({
		// elements: {
		// 	selectors: ['.navi']
		// },
		document: false
	});

	// console.log(jquery);
	// console.log('lol base');
	// console.log(lazySizes);
	// console.log(respImg);
	// console.log(malihu_custom_scrollbar_plugin)

	// Change D3's SI prefix to more business friendly units
	//      K = thousands
	//      M = millions
	//      B = billions
	//      T = trillion
	//      P = quadrillion
	//      E = quintillion
	// small decimals are handled with e-n formatting.
	//--
	// var d3_formatPrefixes_strings = ["e-24","e-21","e-18","e-15","e-12","e-9","e-6","e-3","","K","M","B","T","P","E","Z","Y"];
	var d3_formatPrefixes_strings = ["y","z","a","f","p","n","\xB5","m","","k","M","G","T","P","E","Z","Y"];
	var d3_formatPrefixes = d3_formatPrefixes_strings.map(d3_formatPrefix);

	//-- Override d3's formatPrefix function
	d3_format.formatPrefix = function(value, precision) {
		var i = 0;
		if (value) {
			if (value < 0) {
				value *= -1;
			}
			if (precision) {
				value = d3_format.round(value, d3_format_precision(value, precision));
			}
			i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
			i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
		}
		return d3_formatPrefixes[8 + i / 3];
	};

	function d3_formatPrefix(d, i) {
		var k = Math.pow(10, Math.abs(8 - i) * 3);
		return {
			scale: i > 8 ? function(d) { return d / k; } : function(d) { return d * k; },
			symbol: d
		};
	};

	function d3_format_precision(x, p) {
		return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
	};

	String.prototype.replaceArray = function(find, replace) {
		var replaceString = this;
		var regex, repla;
		for (var i = 0; i < find.length; i++) {
			regex = new RegExp(find[i], "g");
			repla = replace[i] ? replace[i] : '';
			replaceString = replaceString.replace(regex, repla);
		}
		return replaceString;
	};

	// Number.prototype.pad = function(size) {
	// 	var s = String(this);
	// 	while (s.length < (size || 2)) {s = "0" + s;}
	// 	// console.log('s->'+s);
	// 	return s;
	// }

	// function zero_pads(num, numZeros) {
	// 	var n = Math.abs(num);
	// 	var zeros = Math.max(0, numZeros - Math.floor(n).toString().length );
	// 	var zeroString = Math.pow(10,zeros).toString().substr(1);
	// 	if( num < 0 ) {
	// 		zeroString = '-' + zeroString;
	// 	}
	// 	return zeroString+n;
	// }

	$.fn.serializeObject = function()
	{
		var o = {};
		var a = this.serializeArray();
		$.each(a, function() {
			if (o[this.name] !== undefined){
				if (!o[this.name].push)
				{
					o[this.name] = [o[this.name]];
				}
				o[this.name].push(this.value || '');
			}
			else
			{
				o[this.name] = this.value || '';
			}
		});
		return o;
	};

	//--
	var Pag = (function() {
		var fun            = {};
		var popups         = {};
		fun.moduleProperty = 1;
		// $.bridget( 'isotope', Isotope );
		// console.log('isotope');

		//-- d3_format.format("02d")(2)


		// look_nude = d3_format.format('02.3f')(look_nude);
		// look_nude = zero_pads(look_nude, '2');
		// console.log('look_nude->'+look_nude);


		fun.init    = function () {
			//--
			var page_name = $('.page_base').attr('data-page');
			var form_auth = false;
			var form_join = false;
			//--
			// window.user_door = false;


			//--
			window.user__auth = null;
			window.user__join = null;


			//--
			$(document).ready(function(){


				var posa			= null;
				var area_posa		= null;
				var area_posa		= null;
				var area_tall		= null;

				posa 			= document.getElementById('pos_a');
				area_posa 		= document.getElementById('pos_a_area');
				area_posb 		= document.getElementById('pos_b_area');
				if(area_posa && area_posb){
					if( (posa.offsetHeight > area_posb.offsetHeight)){
						// area_posa.style.height = posa.offsetHeight+'px';
						area_tall = posa.offsetHeight;
					}
					else{
						area_tall = area_posb.offsetHeight;
						// area_posa.style.height = area_posb.offsetHeight+'px';
					}
					area_posa.style.height = area_tall+'px';
				}

				//--
				var menu = $('.main_head--spin .menu_head .navi_site_main_a .headbar .navi_navi');
				//--
				if(0 < menu.length ){
					if(0 < menu.find('ul.navi_menu li.current_page_item').length ){
						//--
						require(['jquery-scrollto'], function(){
							menu
							.stop(true)
							.scrollTo(
								//--
								menu.find('ul.navi_menu li.current_page_item'),
								{
									offset: { top:(0) },
									duration: 200,
									interrupt: true,
									onAfter:
									function(){
										// console.log('lalalala');
									}
								}
							);
						});

						// .on('click', 'a', function(clic_evnt){
						// 	//--
						// 	clic_evnt.preventDefault();
						// 	//--
						// 	var clic = $(this);

						// 	var move_posx = 0;

						// 	// var curr = $('.headbar .navi_navi ul.navi_menu li.current_page_item');
						// 	var curr = $('.headbar .navi_navi ul.navi_menu li.current_page_item');
						// 	//var hook = $(this).parent()
						// 	var hook = clic

						// 	var curr_sort = $('.headbar .navi_navi ul.navi_menu li').index(curr);
						// 	var hook_sort = $('.headbar .navi_navi ul.navi_menu li').index(hook);

						// 	move_posx =- hook.position().left + $('.headbar .navi_navi').width() / 2 - hook.width() / 2;

						// 	$('.headbar .navi_navi ul.navi_menu').css('transform', 'translateX(' + move_posx + 'px)');
						// 	curr.removeClass('current_page_item');
						// 	hook.addClass('current_page_item');
						// });
					}
				}

				//--
				$('.pict_foot').each(function(i, jobj){
					// return false;
					//--
					var pict_foot = $(this);
					var wrap = pict_foot.parent();
					var pict_back = wrap.find('.pict_back');
					var deep = pict_foot.attr('data-deep');
					var dimh = pict_foot.height();
					var text_root = pict_foot.find('.text_root');
					var text_chil = pict_foot.find('.text_child');
					var link = pict_foot.find('a.link');
					var text_chil_h = text_chil.find('.__content').height();

					if(deep == "1"){
						// wrap.css({'padding-bottom': dimh+'px'});
						// pict_foot.addClass('absolute absolute-left absolute-bottom');
					}
					//--
					// text_root.attr('data-less', text_root.height() );
					text_chil.attr('data-less', (text_chil.height())*1 );

					//--
					// text_root.attr('data-more', text_chil.find('.__content').height() );
					text_chil.attr('data-more', (text_chil.find('.__content').height())*1 );

					//--
					pict_foot.on('click', 'a', function(hook){
						hook.preventDefault();
						var clic = $(this);
						// console.log('click on a link');

						//--
						// console.warn('root more: ' + text_root.attr('data-more') );
						// console.warn('chil more: ' + text_chil.attr('data-more') );
						//--
						// console.warn('root less: ' + text_root.attr('data-less') );
						// console.warn('chil less: ' + text_chil.attr('data-less') );


						//--
						require(['jquery-scrollto'], function() {

							// $(window).stop(true).scrollTo($(clic.attr('href')), {offset: {top:-(70)}, duration:200, interrupt:true, onAfter: function(){

							// }});

							// console.log($('#'+oid).height());
							//--
							if( clic.hasClass('show_more') ){
								// console.log('show_more');

								//--
								// console.info('root more: ' + text_root.attr('data-more') );
								// console.info('chil more: ' + text_chil.attr('data-more') );

								// text_root.removeClass('line--ss_s3x--auto');
								// text_chil.removeClass('line--ss_s3x--auto');
								// text_root.css('height', '');
								// text_chil.css('height', '');

								// text_root.addClass('line--ss_s3x--auto');
								// text_chil.addClass('line--ss_s3x--auto');

								// text_root.css('height', text_root.attr('data-more')+'px' );
								//--
								pict_back.addClass('pict_back__live');
								//--
								setTimeout(function(){
									//--
									text_chil.css({'height':(text_chil.attr('data-more')*1)+'px'/*, 'padding-top': (text_chil.attr('data-more')*1)+'px'*/ });
								}, 100);

								//--
								clic.removeClass('show_more');
								clic.addClass('show_less');
							}
							else
							{
								if( clic.hasClass('show_less') ){


									// console.log('show_less');

									//--
									// console.info('root less: ' + text_root.attr('data-less') );
									// console.info('chil less: ' + text_chil.attr('data-less') );

									// text_root.removeClass('line--ss_s3x--auto');
									// text_chil.removeClass('line--ss_s3x--auto');

									// text_root.css('height', text_root.attr('data-less')+'px' );

									//--
									pict_back.removeClass('pict_back__live');
									//--
									setTimeout(function(){
										//--
										text_chil.css({'height': (text_chil.attr('data-less')*1)+'px' /*,'padding-top': (text_chil.attr('data-less')*0)+'px'*/ });
									}, 100);

									//--
									clic.removeClass('show_less');
									clic.addClass('show_more');
								}
							}

						});


					});
				});

				//--
				// window.user = $('.modal.door');


				// //--
				// if(typeof(window.busy) === 'undefined'){
				// 	window.busy = Busy;
				// }
				// //--
				// window.busy.Show();

				// //--
				// require(['jquery', 'jquery_validate_am', 'bootstrap_datetimepicker', 'moment', 'mdl_tabs', 'mdl_button', 'mdl_textfield', 'mdl_ripple', 'user', 'note'],
				// 	function(jquery, jquery_validate_am, bootstrap_datetimepicker, moment, mdl_tabs , mdl_button , mdl_textfield , mdl_ripple, User, Note) {

				// 		// console.log(moment.utc([2011, 0, 1, 8]));
				// 		// console.log(moment().subtract(20, "years").format("DD/MM/YYYY"));

				// 		//--
				// 		if(typeof(window.note) === 'undefined'){
				// 			// console.info('click:user__auth-> typeof(window.user_door.data(\'bs.modal\'))'+'==='+'undefined');
				// 			window.note = Note;
				// 		}

				// 		//--
				// 		if(typeof(window.user) === 'undefined'){
				// 			// console.info('click:user__auth-> typeof(window.user_door.data(\'bs.modal\'))'+'==='+'undefined');
				// 			window.user = User;
				// 		}

				// 		//--
				// 		window.note.Make();

				// 	}
				// );


				//--
				$('[data-feed]').each(function(i, item){
					var jobj = $(this);
					var feed = jobj.attr('data-feed');
					// console.log(feed);

					// // //--
					// // var Y = require(['../libr/yui/yui/yui']);
					// // var Y = require(['../libr/yui/yui/yui']);
					// console.log(yui_yql);   // => YQL #1? true
					// // console.log('YUI #1?', YUI ? true : false);   // => YQL #1? true
					// // console.log('YQL #1?', YUI.YQL ? true : false);   // => YQL #1? true

					// YUI().use('yql', function(Y) {

					// 	// var resp = y.rest("http://www.apache.org").header("Accept-Encoding","gzip").get();
					// 	// var resp = Y.rest("www.example.com").header("Accept-Encoding","gzip").decompress(true).get();
					// 	// response.object = resp;
					// 	// console.log('lol');
					// 	// console.log(response.object);
					// 	Y.YQL('select * from feed where url = "'+feed+'" limit 1', function(data) {
					// 		console.log(data);
					// 			//data now contains the result of the YQL Query
					// 			//use the YQL Developer console to learn
					// 			//what data is coming back in this object
					// 			//and how that data is structured.

					// 			// console.dir(data.results);
					// 			var data = data.query.results;
					// 			// $('#weather').append($('<h2/>').text(channel.description));
					// 			$.each(data, function(sort, item){
					// 				var data_heading = item.title;
					// 				var data_summary = item.summary;
					// 				var data_linking = item.link[0];
					// 				jobj.find('.data_heading .__content').text(data_heading);
					// 				jobj.find('.data_summary .__content').text(data_summary);
					// 				// console.log(data_linking);
					// 				console.log(data_linking.href);
					// 				// console.log(data_heading);
					// 				// console.log(data_summary);
					// 				// console.log(item);s
					// 			// 	if (item.description) { $('#weather').append($('<p/>').html(item.description)); }
					// 			});


					// 		},
					// 		{
					// 			'format': 'json'
					// 			,
					// 			'crossProduct': 'optimized'
					// 		}
					// 	);

					// });
				});

				//-- Detect browser scroll bar width
				$(document)
				.on('hidden.bs.modal', '.modal', function(evt) {
					//-- use margin-right 0 for IE8
					// $(document.body).css('margin-right', '');
					$(document.body).removeClass('modal-open-noscroll');
					// console.log('hidden.bs.modal');
				})
				.on('show.bs.modal', '.modal', function() {
					// console.log('->'+scrollBarWidth);
					// When modal is shown, scrollbar on body disappears.  In order not
					// to experience a "shifting" effect, replace the scrollbar width
					// with a right-margin on the body.
					// console.log('show.bs.modal');
					if ($(window).height() < $(document).height()) {
						// $(document.body).css('margin-right', scrollBarWidth + 'px');
						$(document.body).addClass('modal-open-noscroll');
					}
				});

				$('#main_find').on('click', 'a.item_area', function(item){
					// console.log('click');
					item.preventDefault();
					$('#main_find form input[type="submit"]').trigger('click');
				});


				$('form.navi_term').on('submit', function(obj){
					// console.log('obj');
					return false;
				});

				var find_tmpl = $('#fake_find input[name="tpl"]').val();
				$('.form_find input[name="tpl"]').val(find_tmpl);
				//--
				if($('.form_find_situ').length > 0){
					$('.form_find_situ input[name="tpl"]').val(find_tmpl);
				}

				// console.log('find_tmpl: '+find_tmpl);

				//--
				$('#navi_side_auth').on('click', '.user__auth', function(item){
					//--
					console.log('click: user__auth');
					//--
					item.preventDefault();
					var item = $(this);

					//--
					if(typeof(window.busy) === 'undefined'){
						window.busy = Busy;
					}
					//--
					window.busy.Show();

					//--
					require(['jquery', 'jquery_validate_am', 'bootstrap_datetimepicker', 'moment', 'mdl_tabs', 'mdl_button', 'mdl_textfield', 'mdl_ripple', 'Facebook', 'user'],
						function(jquery, jquery_validate_am, bootstrap_datetimepicker, moment, mdl_tabs , mdl_button , mdl_textfield , mdl_ripple, Facebook, User) {

							// console.log(moment.utc([2011, 0, 1, 8]));
							// console.log(moment().subtract(20, "years").format("DD/MM/YYYY"));

							//--
							if(typeof(window.user) === 'undefined'){
								// console.info('click:user__auth-> typeof(window.user_door.data(\'bs.modal\'))'+'==='+'undefined');
								window.user = User;
							}
							//--
							window.user.Auth();

						}
					);
				});


				//--
				$('#main_nets').on('click', '.user__join', function(item){
					//--
					item.preventDefault();
					var item = $(this);

					//--
					if(typeof(window.busy) === 'undefined'){
						window.busy = Busy;
					}
					//--
					window.busy.Show();

					//--
					require(['jquery', 'jquery_validate_am', 'bootstrap_datetimepicker', 'moment', 'mdl_tabs', 'mdl_button', 'mdl_textfield', 'mdl_ripple', 'Facebook', 'user'],
						function(jquery, jquery_validate_am, bootstrap_datetimepicker, moment, mdl_tabs , mdl_button , mdl_textfield , mdl_ripple, Facebook, User) {

							//--
							if(typeof(window.user) === 'undefined')
							{
								// console.info('click:user__join-> typeof(window.user_door.data(\'bs.modal\'))'+'==='+'undefined');
								window.user = User;
							}
							//--
							window.user.Join();

						}
					);

				});

				//--
				var datatype = $('.page[data-page]').attr('data-page');

				// //--
				// $(document).on('submit','form#auth',function(item){
				// 	// code
				// 	item.preventDefault();
				// 	var item = $(this);
				// 	console.log('lel');

				// 	//-- Path
				// 	var path = '/api/users/login.json';


				// 	var data = {};
				// 	data = item.serialize();
				// 	data['_format:'] = 'json';

				// 	$.ajax({
				// 		url: path
				// 		,
				// 		type: 'POST'
				// 		,
				// 		// contentType: "application/json"
				// 		// ,
				// 		dataType: "json"
				// 		,
				// 		data: data
				// 		,
				// 		success:
				// 		$.proxy(function(response) {
				// 			console.dir(response);
				// 			if(response.good) {


				// 			}
				// 			else {
				// 				// bootbox.alert(response.message);
				// 			}
				// 		}, this)
				// 	});

				// 	return false;
				// });


				//--
				$('.human-number').each(function(i, obj){
					var item = null;
					var read = 0;
					item = $(obj);
					read = item.attr('data-read');
					// read = 5500;
					var find = '';
					var over = '';
					var pref = ''
					var scal = '';
					var pict = '';
					var look = '';

					//--
					// console.log('->' + i + ' read ' + read );

					//--
					if(read >= 10000)
					{
						find = d3_formatPrefixes_strings;
						over = d3_format.format('.3s');
						pref = d3_format.formatPrefix(read);
						pict = pref.symbol;
						scal = pref.scale(read);

						look = over(read);

						// console.log('look '+look);
						look = look.replaceArray(find, []);
						// look = parseFloat(look);

						// //--
						// console.log('find '+find);
						// console.log('pict '+pict);
						// console.log('scal '+scal.toFixed());
						// console.log('look '+look);
					}
					else
					{
						// look = zero_pads(read, '4');
						look = read;
					}

					//--
					// console.log('look->'+look);

					//--
					item.find('.human-number__data').text(look);
					item.find('.human-number__pict').text(pict);
				});


				// //--
				// ruta_iso = Backbone.history.getFragment().substring(0,3);
				// ruta_url = '/'+Backbone.history.getFragment().substring(0,3)+'/'+window.BB.find_url.substring(4, window.BB.find_url.length);


				//--
				$('body')
				.on("mouseenter", '.ad_728x90 .view_area .view', function() {
					// .on("mouseenter", 'iframe[id="google_ads_iframe_/7138529/728x90_home_0"]', function() {
					// $(this).css('height', '400px');
					$(this).find('.Desktop_Head_1 > div > iframe').css('height', '400px');
				})
				.on("mouseleave", '.ad_728x90 .view_area .view', function() {
					// .on("mouseleave", 'iframe[id="google_ads_iframe_/7138529/728x90_0"]', function() {
					// $(this).css('height', '90px');
					$(this).find('.Desktop_Head_1 > div > iframe').css('height', '90px');
				});


				//--
				if (window.data.nake != '1' && window.data.glob_data.http_user_agent_gbot!="1")
				{
					//--
					$('.view_area .view .adunit').each(function(view_sort, view_item){
						var that = $(this);
						//--
						that
						.dfp({
							dfpID:'7138529',
							afterEachAdLoaded:
							function(adUnit){
								adUnit.parents('.view').addClass('view_hide')
							}
						});
					});

					// //--
					// $.dfp({
					// 	dfpID:'7138529',
					// 	afterEachAdLoaded:
					// 	function(adUnit){
					// 		adUnit.parents('.view').addClass('view_hide')
					// 	}
					// });
				}


				// window.BB.find_url = ruta_url;
				if( (page_name == 'home' || window.data.shot.name == 'Sala Negra' || window.data.shot.name == 'El Salvador') && window.data.glob_data.http_user_agent_gbot!="1"){

					//--
					lens = $('.lens');
					//--
					lens.modal({ backdrop: 'static', keyboard: false, show: false });
					//--
					// less.off('keyup.dismiss.bs.modal');
					lens.data('bs.modal').options.keyboard = false;
					lens.data('bs.modal').options.backdrop = 'static';

					//--
					//-- CALLBACKS
					//--
					lens
					.on('show.bs.modal', function (){
						//--
						// console.log('Show');
						//--
						lens
						.find('a')
						.addClass('hidden');
					})
					.on('hide.bs.modal', function (){
						//--
						// lens.find('.page_head_area .page_head').text('...');
						// console.log('Hide');
					})
					//-- MOSTRADO
					.on('shown.bs.modal', function () {
						//--
						// lens.find('.page_head_area .page_head').html(header);
						// console.log('Shown');
						setTimeout(function(){
							//--
							lens.modal('hide');
						}, 20000);
						setTimeout(function(){
							//--
							lens
							.find('a')
							.removeClass('hidden');
						}, 0);
						// }, 1500);
					})
					//-- OCULTADO
					.on('hidden.bs.modal', function () {
						// console.log('Hidden');
					});


					//--
					if (window.data.nake != '1')
					{
						//--
						setTimeout(function(){
							//--
							lens.modal('show');
						}, 1000);
					}
				}


				//--
				$('body')
				.on("mouseenter", 'iframe[id="google_ads_iframe_/7138529/728x90_nacionales_0"]', function() {
					$(this).css('height', '400px');
				})
				.on("mouseleave", 'iframe[id="google_ads_iframe_/7138529/728x90_nacionales_0"]', function() {
					$(this).css('height', '90px');
				});




				$('#col_rows').on('click', '#more', function(item){
					console.info('click #col_rows');
					item.preventDefault();

					var item = $(this);
					var icon = item.find('.pict.icon');
					var char = item.find('.pict.char');
					var data = {};
					var tmpl = false;
					var file_tmpl = '';

					//--
					window.busy.Show();

					//-- Tmpl
					tmpl = item.attr('data-tmpl');

					//-- Site
					site = item.attr('data-site');

					//-- Path
					path = item.attr('data-path');

					//-- Mtag
					path_mtag = item.attr('data-path_mtag');

					//-- Noun Name
					noun_name = item.attr('data-noun-name');

					//-- List ID
					data_id = item.attr('data-id');

					data_in = item.attr('data-in');

					//-- Page Number
					page = item.attr('data-page');
					// console.log('page'+'->'+page);
					page = typeof(page) === 'undefined' ? 1 : parseInt(page);
					console.log('page'+'->'+page);

					//-- Per Page
					items_per_page 	= item.attr('data-items_per_page');
					items_per_page 	= parseInt(items_per_page);

					// //-- Page Number Next
					// page_next = item.attr('data-page_next') | 2;

					//-- Page Total
					items_count = item.attr('data-items_count');
					// items_pivot = item.attr('data-items_pivot');

					//-- Number Page
					// items_pivot = data_in=='1' ? 0 : ((page)*(items_per_page));
					items_pivot = data_in=='1' ? 0 : ((page)*(items_per_page));

					//-- Year
					file_year = item.attr('data-year');
					//-- Month
					file_month = item.attr('data-month');
					// //-- Filter Issue
					// file_fi = item.attr('data-fi');
					// //-- Filter Section
					// file_fs = item.attr('data-fs');

					//-- Filter published_after
					published_after = item.attr('data-published_after');
					//-- Filter published_before
					published_before = item.attr('data-published_before');

					//-- Filter Topic
					topic = item.attr('data-topic');
					// //-- Filter Section
					// section = item.attr('data-section');

					// console.log('data_id: '+data_id);

					console.log('page: '+page);
					// console.log('items_count: '+items_count);
					console.log('items_per_page: '+items_per_page);

					// console.log('file_year: '+file_year);
					// console.log('file_month: '+file_month);

					// console.log('file_fi: '+file_fi);
					// console.log('file_fs: '+file_fs);

					// //--
					// console.log('topic: '+topic);
					// console.log('data_id: '+data_id);
					console.log('items_pivot: '+items_pivot);
					// console.log('section: '+section);
					// console.log('items_per_page: '+items_per_page);
					// console.log('published_after: '+published_after);
					// console.log('published_before: '+published_before);
					// console.log('page: '+(page+1) );

					//--
					if(icon.hasClass('pict-control_point')){
						icon.removeClass('pict-control_point')
						icon.addClass('pict-schedule');
						char.text(' Cargando...');
					}

					//--
					data['ug'] 				= 1;
					// data['status'] 				= 'Y';

					//--
					if(site!='elfaro.netz')
					{

						// data['page'] 			= page+1;

						data[data_id] = ( items_pivot );

						// data['format'] 			= 'json';

						// data['items_count'] = items_count;

						// data['items_per_page'] 	= items_per_page;

						// data['year'] = file_year;
						// data['month'] = file_month;

						//--
						if(published_after!='')
						{
							data['published_after'] = published_after;
						}
						if(published_before!='')
						{
							data['published_before'] = published_before;
						}

						//--
						// if(topic!='')
						if(path_mtag!='')
						{
							// data['topic'] = topic;
							path = path+'/'+path_mtag;
						}
						// if(section!='')
						// {
						// 	data['section'] = section;
						// }

					}

					//--
					// if(topic!='')
					if(noun_name!='')
					{
						data['author'] = noun_name;
					}

					//--
					item.attr('data-page', (page));

					// console.log('page: '+page);
					// console.log(page);

					//--
					// item.attr('data-items_pivot', items_pivot);
					// console.log('page'+'->'+page);

					item.attr('data-page', (page+1) );

					//--
					var form_away = false;

					//--\send_form
					send_form = function(){

						if (!form_away) {
							form_away = true;
							//--
							$.ajax({
								url: path
								,
								type: 'GET'
								,
								contentType: "application/json"
								,
								dataType: "json"
								,
								data: data
								,
								success:
								$.proxy(function(response) {


									//--
									item.attr('data-path_mtag_back', path_mtag);


									//--
									window.busy.Hide();


									if(icon.hasClass('pict-schedule')){
										icon.removeClass('pict-schedule')
										icon.addClass('pict-control_point');
										char.html(' Ver m&aacute;s');
									}

									// //--
									// if(response.pagination && response.pagination.currentPage)
									// {
									// 	page = response.pagination.currentPage;
									// }
									// else{
									// 	page = "1";
									// }

									// //--
									// if(response.pagination && response.pagination.nextPageLink)
									// {
									// 	page_next = response.pagination.nextPageLink;
									// }
									// else{
									// 	page_next = '-1';
									// }

									//--
									if(response.more.data_page_next && response.more.data_page_next)
									{
										page_next = response.more.data_page_next;
									}
									else{
										page_next = '-1';
									}

									//--
									item.attr('data-in', '0');
									item.attr('data-page_next', page_next);

									// console.log('page_next: '+page_next);

									//--
									if(page_next <= '-1'){
										item.addClass('hidden');
									}

									// var tmpl = Handlebars.compile($("#item_list-template").html());
									// console.log(tmpl);
									// console.log( $(tmpl(response)) );
									// // $(tmpl(response)).insertBefore(this);
									// // $(this).data('page', page + 1);

									// // if(response.pagination.total_pages == response.pagination.current_page) {
									// // 	$(this).addClass('hide');
									// // }

									if( ('undefined' === (typeof tmpl)) || (tmpl=='') || (tmpl==null) || (tmpl==false) )
									{
										file_tmpl = 'part_list_item';
									}
									else{
										file_tmpl = tmpl;
									}

									require(['hbs!./../resources/views/hbs/hbs_part/_'+file_tmpl], function ( tmpl ) {
										//--
										// console.log('tmpl.helpers: '+tmpl.helpers);
										//--
										var list_data_more = tmpl(response);
										$('#list_data').append(list_data_more);
										//--
										setTimeout(function(){
											//--
											console.log('window.obvp: ', window.obvp);
											//--
											window.resp(window.obvp);
										}, 100)
									});


								}, this)
							});
						}

					}
					//--/send_form

					//--
					setTimeout(send_form, 5000);

					require(['GoogleAnalytics'], function(GoogleAnalytics){
						GoogleAnalytics.ready(function(liba){
							console.info('page: '+page);
							console.info('typeof page: '+(typeof page));
							//--
							// liba('send', {hitType: 'event', eventCategory: 'Ver_MÃ¡s|'+location.host+location.pathname, eventAction: 'Clic', eventLabel: '{Site: ' + window.data.site.name + ', Tmpl: ' + window.data.tmpl_slug + ', Path: ' + location.pathname + '}', eventValue: (page+1), hitCallback: function(){
							liba('send', {hitType: 'event', eventCategory: 'View More', eventAction: 'Clic', eventLabel: location.host+location.pathname, eventValue: (page+1), hitCallback: function(){
								console.info('GoogleAnalytics Event hitCallback');
								send_form();
							}});

						});
					});

				});
			});


			//--
			require(
				['Facebook'],
				function(Facebook) {


					if(typeof Facebook != 'undefined'){
						//--
						//-- FACEBOOK
						//--
						$(document.body).on('click', '.facebook .logout', function (event) {
							return Facebook.logout(function () {
								// return console.info('Facebook: logged out');
								// return console.info('Facebook: logged out');
							});
						});

						$(document.body).on('click', '.facebook .uninstall', function (event) {
							return Facebook.uninstallApp(function () {
								// return console.info('Facebook: App uninstalled from user');
							});
						});

						//--
						$(document.body).on('click', 'button[data-fb-login]', function (event) {
							// console.info('BotÃƒÂ³n Login');
							event.preventDefault();
							var scope;
							scope = $(this).attr('data-fb-login');
							return Facebook.login({
								scope: scope,
								onLogin: function (authResponse) {
									// var settings = form_join.validate().settings;
									// console.info('authResponse.signedRequest: '+authResponse.signedRequest);
									// $.extend(settings, {rules: {} });

									// console.info('Permissions: ', Facebook.getPermissions());

									//--
									Facebook.getUserInfo(['id','first_name','last_name','email'], function(resp){
										// console.info('Permissions: ', Facebook.getPermissions());
										// console.info('Response: ', resp);
										// form_join.find('input[name="socl_sing"]').val(authResponse.signedRequest);
										// form_join.find('input[name="socl_obid"]').val(resp.id);
										// form_join.find('input[name="socl_mail"]').val(resp.email);
										// form_join.find('input[name="socl_name_a"]').val(resp.first_name);
										// form_join.find('input[name="socl_name_b"]').val(resp.last_name);
										// form_join.submit();
									});

									//--
									// return console.info('Facebook: logged in', authResponse);
								},
								onCancel: function () {
									// return console.info('Facebook: login canceled');
								}
							});
						});

						//--
						$(document.body).on('submit', '.facebook form.permissions', function (event) {
							event.preventDefault();
							var checked, el, form, requestedFields, resultsOutput;
							form = event.target;
							resultsOutput = $(form).find('textarea');
							checked = $(form).find('input:checked');
							//--
							// console.log('->' + checked);
							// console.log(checked);
							//--
							requestedFields = (function () {
								var i, len, results;
								results = [];
								for (i = 0, len = checked.length; i < len; i++) {
									el = checked[i];
									console.info($(el).attr('value'));
									results.push($(el).attr('value'));
								}
								return results;
							})();
							return Facebook.requireUserInfo(requestedFields, function (response) {
								// console.info('Facebook.requireUserInfo');
								// console.log(response);
								return resultsOutput.val(JSON.stringify(response, null, 2));
							});
						});

						//--
						Facebook.on('onAuthChange', function (loggedIn) {
							if (loggedIn) {
								// return console.info('Facebook: The user logged in');
							} else {
								// return console.info('Facebook: The user logged out');
							}
						});

						//--
						Facebook.on('logout', function () {
							// return console.info('Facebook: user logged out');
						});

						//--
						Facebook.getAccessToken(function (token) {
							// console.info('Facebook: token: ' + token);
						});
					}


				}
			);


		};

		return fun;

	}());
	return Pag;
});
